import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsRequestPage.PrintPreviewPopup', {
    unnamedReportName: 'Unnamed report',
    windowTitle: '{reportName} | {companyName} | ApprovalMax',
    loadingData: 'Loading data...',
    reportNameHeaderText: '"{reportName}" Report',
});
